module.exports = __webpack_public_path__ + "public/files/img/feedback.2a9b0af7.jpg";